/**
 * La campana de alertas activas. Dibujado a mano, como `EngranajeIcono` y
 * `OjoIcono`.
 */
export function CampanaIcono() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
      <path
        d="M6.3 17c.5-.9 1.2-2.9 1.2-6.2a4.5 4.5 0 0 1 9 0c0 3.3.7 5.3 1.2 6.2z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <line x1="5.6" y1="17" x2="18.4" y2="17" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path
        d="M10.2 20a1.9 1.9 0 0 0 3.6 0"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}
